import React, { useState, useEffect } from "react";
import { createActivity, updateActivity } from "../api/activityService";
import { fetchActivityTypes } from "../api/activityService";

function AddEditActivityModal({ isOpen, onClose, isEditing, activity, leadId }) {
  const [formData, setFormData] = useState({
    activity_type_id: "",
    activity_status_id: "1",  // Default status
    description: "",
    scheduled_at: "",
    status: "Pending",
    assigned_to: "",
    notes: "",
    is_follow_up: false,
    follow_up_date: "",
    follow_up_time: "",
  });
  const [activityTypes, setActivityTypes] = useState([]);

  useEffect(() => {
    if (isEditing && activity) {
      setFormData({
        activity_type_id: activity.activity_type_id || "",
        activity_status_id: activity.activity_status_id || "1",
        description: activity.description || "",
        scheduled_at: activity.scheduled_at || "",
        status: activity.status || "Pending",
        assigned_to: activity.assigned_to || "",
        notes: activity.notes || "",
        is_follow_up: activity.is_follow_up || false,
        follow_up_date: activity.follow_up_date || "",
        follow_up_time: activity.follow_up_time || "",
      });
    } else {
      setFormData({
        type: "",
        summary: "",
        date: "",
        time: "",
        status: "Pending",
        assigned_to: "",
        notes: "",
        is_follow_up: false,
        follow_up_date: "",
        follow_up_time: "",
      });
    }
  }, [isEditing, activity]);

  useEffect(() => {
       const getActivityTypes = async () => {
         try {
           const types = await fetchActivityTypes();
           setActivityTypes(types || []); // Ensure it's always an array
         } catch (error) {
           console.error("Failed to fetch activity types:", error);
         }
       };
    
           getActivityTypes();
     }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({ ...prev, [name]: type === "checkbox" ? checked : value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.activity_type_id || !formData.description || !formData.scheduled_at) {
      alert("Please fill in all required fields.");
      return;
  }

    try {
      if (isEditing) {
        await updateActivity(activity.activity_id, {
                 activity_type_id: formData.activity_type_id,
                 activity_status_id: formData.activity_status_id,
                 description: formData.description,
                 scheduled_at: formData.scheduled_at,
                 assigned_to: formData.assigned_to,
                 is_follow_up: formData.is_follow_up,
                 follow_up_date: formData.follow_up_date,
                 follow_up_time: formData.follow_up_time,
                 lead_id: leadId
              });
      } else {
             await createActivity({
                 activity_type_id: formData.activity_type_id,
                 activity_status_id: formData.activity_status_id,
                 description: formData.description,
                 scheduled_at: formData.scheduled_at,
                 assigned_to: formData.assigned_to,
                 is_follow_up: formData.is_follow_up,
                 follow_up_date: formData.follow_up_date,
                 follow_up_time: formData.follow_up_time,
                 lead_id: leadId
               });
      }
      onClose();
    } catch (error) {
      console.error("Error saving activity:", error);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-4xl flex flex-col h-[90vh]">
        <div className="px-6 py-4 border-b bg-gray-100 flex justify-between items-center">
          <h2 className="text-xl font-semibold text-gray-700">
            {isEditing ? "Edit Activity" : "Add Activity"}
          </h2>
          <button onClick={onClose} className="text-gray-600 hover:text-gray-900 text-2xl">
            &times;
          </button>
        </div>

        <div className="flex-1 overflow-y-auto p-6">
          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              <div>
                <label htmlFor="type" className="block text-sm font-medium text-gray-700 mb-1">
                  Activity Type <span className="text-red-500">*</span>
                </label>
                <select name="activity_type_id" id="activity_type_id" value={formData.activity_type_id} onChange={handleChange}
                  className="w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
                  required
                >
                <option value="">Select Type</option>
                    {activityTypes.map((type) => (
                    <option key={type.id} value={type.id}>
                    {type.name}
                    </option>
                ))}
                </select>
              </div>

              <div>
                <label htmlFor="summary" className="block text-sm font-medium text-gray-700 mb-1">
                  Summary <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="summary"
                  id="summary"
                  value={formData.summary}
                  onChange={handleChange}
                  className="w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
                  placeholder="Brief description"
                  required
                />
              </div>

              <div>
                <label htmlFor="date" className="block text-sm font-medium text-gray-700 mb-1">
                  Date <span className="text-red-500">*</span>
                </label>
                <input type="datetime-local" name="scheduled_at" id="scheduled_at" value={formData.scheduled_at} onChange={handleChange}
                  className="w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
                  required
                />
              </div>

              <div>
                <label htmlFor="time" className="block text-sm font-medium text-gray-700 mb-1">
                  Time <span className="text-red-500">*</span>
                </label>
                <input type="datetime-local" name="scheduled_at" id="scheduled_at" value={formData.scheduled_at} onChange={handleChange}
                  className="w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
                  required
                />
              </div>

              <div>
                <label htmlFor="status" className="block text-sm font-medium text-gray-700 mb-1">
                  Status
                </label>
                <select
                  name="status"
                  id="status"
                  value={formData.status}
                  onChange={handleChange}
                  className="w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
                >
                  <option value="Pending">Pending</option>
                  <option value="Completed">Completed</option>
                </select>
              </div>

              <div>
                <label htmlFor="assignedTo" className="block text-sm font-medium text-gray-700 mb-1">
                  Assigned To
                </label>
                <input
                  type="text"
                  name="assignedTo"
                  id="assignedTo"
                  value={formData.assignedTo}
                  onChange={handleChange}
                  className="w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
                  placeholder="Assignee name"
                />
              </div>

              <div className="col-span-1 md:col-span-2 lg:col-span-3">
                <div className="flex items-center">
                  <input
                    type="checkbox"
                    name="followUp"
                    id="followUp"
                    checked={formData.followUp}
                    onChange={handleChange}
                    className="mr-2"
                  />
                  <label htmlFor="followUp" className="block text-sm font-medium text-gray-700">
                    Enable Follow-up
                  </label>
                </div>
              </div>

              {formData.followUp && (
                <>
                  <div>
                    <label htmlFor="followUpDate" className="block text-sm font-medium text-gray-700 mb-1">
                      Follow-Up Date
                    </label>
                    <input
                      type="date"
                      name="followUpDate"
                      id="followUpDate"
                      value={formData.followUpDate}
                      onChange={handleChange}
                      className="w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
                    />
                  </div>
                  <div>
                    <label htmlFor="followUpTime" className="block text-sm font-medium text-gray-700 mb-1">
                      Follow-Up Time
                    </label>
                    <input
                      type="time"
                      name="followUpTime"
                      id="followUpTime"
                      value={formData.followUpTime}
                      onChange={handleChange}
                      className="w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
                    />
                  </div>
                </>
              )}
            </div>
          </form>
        </div>

        <div className="px-6 py-4 border-t bg-gray-100 flex justify-end space-x-4">
          <button type="button" onClick={onClose} className="bg-gray-200 text-gray-700 px-4 py-2 rounded-md hover:bg-gray-300">
            Cancel
          </button>
          <button type="submit" onClick={handleSubmit} className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-500">
            {isEditing ? "Save Changes" : "Add Activity"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default AddEditActivityModal;